import { DeliveryType } from '@/lib/consts';

import { DocumentTypeCode, UserData, UserRequestDraft, UserService } from '@/api/types';

import { ExtractRedeliveryMergedSchema } from '../model/types';

interface Props {
  withAttachments: boolean;
  requestId: UserRequestDraft['id'];
  formData: ExtractRedeliveryMergedSchema;
  service: UserService;
  userData: Nullable<UserData>;
}

export const generatePayload = async ({
  requestId,
  service,
  formData,
  userData,
}: Props): Promise<Record<string, any>> => {
  const extractRedeliveryDocumentInfo = formData.documents[formData.extractRedeliveryDocument?.code]?.info;

  const basePayload = {
    requestId,
    service: {
      id: service.id,
      name: service.name,
      code: service.code,
    },
    delivery_type: formData.deliveryType.id,
    user: {
      first_name: formData.firstName,
      last_name: formData.lastName,
      patronymic: formData.middleName,
      birthday: userData?.date_of_birth,
      email: formData.email,
      phones: formData.phones,
      sex: userData?.gender,
    },
    address_delivery: {
      index: formData.indexNumber,
      warehouse: `${formData.deliveryType.id === DeliveryType.COURIER ? formData.warehouse.id : formData.warehouse.label}${formData.building ? `, корпус ${formData.building}` : ''}${formData.apartment ? `, квартира ${formData.apartment}` : ''}`,
    },
    // TODO: Refactor MVSUSLUH-4833
    documents: [
      {
        type: formData.extractRedeliveryDocument?.code,
        fields: {
          type: formData.extractRedeliveryDocument?.code,
          typeName: formData.extractRedeliveryDocument?.label,
          ...(formData.extractRedeliveryDocument?.code === DocumentTypeCode.PASSPORT && {
            referenceNumber: extractRedeliveryDocumentInfo.serialNumberDoc,
            issue: extractRedeliveryDocumentInfo.auth_dep,
            dateIssue: extractRedeliveryDocumentInfo.date,
          }),
          ...(formData.extractRedeliveryDocument?.code === DocumentTypeCode.ID_CARD && {
            referenceNumber: extractRedeliveryDocumentInfo.serialNumberDoc,
            issue: extractRedeliveryDocumentInfo.auth_dep,
            dateIssue: extractRedeliveryDocumentInfo.date,
            expiredDate: extractRedeliveryDocumentInfo.expirationDate,
            unzr: extractRedeliveryDocumentInfo.unzr,
          }),
          ...(formData.extractRedeliveryDocument?.code === DocumentTypeCode.INTERNATIONAL_PASSPORT && {
            referenceNumber: extractRedeliveryDocumentInfo.serialNumberDoc,
            issue: extractRedeliveryDocumentInfo.auth_dep,
            dateIssue: extractRedeliveryDocumentInfo.date,
            expiredDate: extractRedeliveryDocumentInfo.expirationDate,
            unzr: extractRedeliveryDocumentInfo.unzr,
          }),
          ...(formData.extractRedeliveryDocument?.code === DocumentTypeCode.RESIDENCE && {
            referenceNumber: extractRedeliveryDocumentInfo.serialNumberDoc,
            issue: extractRedeliveryDocumentInfo.auth_dep,
            dateIssue: extractRedeliveryDocumentInfo.date,
            expiredDate: extractRedeliveryDocumentInfo.expirationDate,
            unzr: extractRedeliveryDocumentInfo.unzr,
          }),
          ...(formData.extractRedeliveryDocument?.code === DocumentTypeCode.OLD_RESIDENCE && {
            referenceNumber: extractRedeliveryDocumentInfo.serialNumberDoc,
            issue: extractRedeliveryDocumentInfo.auth_dep,
            dateIssue: extractRedeliveryDocumentInfo.date,
          }),
          ...(formData.extractRedeliveryDocument?.code === DocumentTypeCode.TEMPORARY_RESIDENCE && {
            referenceNumber: extractRedeliveryDocumentInfo.serialNumberDoc,
            issue: extractRedeliveryDocumentInfo.auth_dep,
            dateIssue: extractRedeliveryDocumentInfo.date,
            expiredDate: extractRedeliveryDocumentInfo.expirationDate,
            unzr: extractRedeliveryDocumentInfo.unzr,
          }),
        },
      },
    ],
    confirm: formData.confirmEnteredDataCorrect,
  };

  return basePayload;
};
